// extracted by mini-css-extract-plugin
module.exports = {"rolesList":"RolesList_rolesList__8rzEc","header":"RolesList_header__3yQj4","grid":"RolesList_grid__18j0J","fadeIn":"RolesList_fadeIn__1oS_l","fadeOut":"RolesList_fadeOut__2xGuk"};